module.exports = __webpack_public_path__ + "static/3d-6de95a60a95bb1a1baf7b585e688deb9.jpg";